var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "domo-embed-list container-fluid" },
    [
      _vm.canManageEmbeds
        ? [
            _c("div", { staticClass: "row mb-4" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center"
                  },
                  [
                    _c("h3", { staticClass: "h4 mb-0" }, [
                      _vm._v("Domo Embed Management")
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function($event) {
                            _vm.showCreateModal = true
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-plus-circle me-1" }),
                        _vm._v(" Create Embed\n        ")
                      ]
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.loading
              ? _c("div", { staticClass: "row" }, [_vm._m(0)])
              : _vm.error
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { role: "alert" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-exclamation-triangle me-2"
                        }),
                        _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
                      ]
                    )
                  ])
                ])
              : !_vm.embeds.length
              ? _c("div", { staticClass: "row" }, [_vm._m(1)])
              : _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body p-0" }, [
                        _c(
                          "table",
                          {
                            staticClass: "table table-striped table-hover mb-0"
                          },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [_vm._v("Embed ID")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Name")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Active")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Created")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Updated")]),
                                _vm._v(" "),
                                _vm.canManageEmbeds
                                  ? _c("th", { staticClass: "text-end" }, [
                                      _vm._v("Actions")
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.embeds, function(embed) {
                                return _c("tr", { key: embed.embed_id }, [
                                  _c("td", [
                                    _c("code", [_vm._v(_vm._s(embed.embed_id))])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(embed.name))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "badge",
                                        class:
                                          embed.active !== false
                                            ? "badge-success"
                                            : "badge-danger"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              embed.active !== false
                                                ? "Active"
                                                : "Inactive"
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.formatDate(embed.created_at))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.formatDate(embed.updated_at))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.canManageEmbeds
                                    ? _c("td", { staticClass: "text-end" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-primary me-2",
                                            attrs: {
                                              type: "button",
                                              title: "Edit",
                                              "aria-label": "Edit " + embed.name
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.editEmbed(embed)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-pencil",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-danger",
                                            attrs: {
                                              type: "button",
                                              title: "Delete",
                                              "aria-label":
                                                "Delete " + embed.name
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.confirmDelete(embed)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-trash",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ]),
            _vm._v(" "),
            (_vm.showCreateModal || _vm.showEditModal) && _vm.canManageEmbeds
              ? _c("DomoEmbedForm", {
                  attrs: {
                    "selected-embed": _vm.currentEmbed,
                    "is-edit": _vm.showEditModal,
                    "on-save": _vm.saveEmbed
                  },
                  on: { close: _vm.closeModal }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showDeleteModal
              ? _c("div", { staticClass: "modal-backdrop" }, [
                  _c(
                    "div",
                    {
                      staticClass: "modal-dialog modal-dialog-centered",
                      attrs: {
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": "deleteModalTitle",
                        tabindex: "-1"
                      }
                    },
                    [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button", "aria-label": "Close" },
                              on: {
                                click: function($event) {
                                  _vm.showDeleteModal = false
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-times",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "h5",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "deleteModalTitle" }
                            },
                            [_vm._v("Confirm Delete")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-body" }, [
                          _c("p", [
                            _vm._v(
                              'Are you sure you want to delete the embed "' +
                                _vm._s(_vm.currentEmbed.name) +
                                '"?'
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v("This action cannot be undone.")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.showDeleteModal = false
                                }
                              }
                            },
                            [_vm._v("\n            Cancel\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: { type: "button" },
                              on: { click: _vm.deleteEmbed }
                            },
                            [_vm._v("\n            Delete\n          ")]
                          )
                        ])
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col text-center py-5" }, [
      _c("p", { staticClass: "mt-3" }, [_vm._v("Loading embeds...")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body text-center py-5" }, [
          _c("i", { staticClass: "fa fa-bar-chart display-4 text-muted mb-3" }),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted" }, [
            _vm._v(
              "\n            No Domo embeds found. Create your first embed to get started.\n          "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }